import { useNavigate } from 'react-router-dom'
import useDimension from '../../../hooks/use-dimension'
import { useGameContext } from '../../../context/GameContext'
import { motion } from 'framer-motion'
import { useAudio } from '../../../context/AudioContext'

export default function EndVideo() {
  const navigate = useNavigate()
  const { ws } = useDimension()
  const { updateVideo, role } = useGameContext()
  const { setVolumeValue } = useAudio()

  const handleVideoEnd = () => {
    updateVideo(() => true)
    setVolumeValue(1)
    navigate('/final', { replace: true })
  }
  if (!role) {
    return <div>Loading...</div>
  }
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <video
        width={360 * ws}
        height={640 * ws}
        autoPlay
        controls
        controlsList="nodownload"
        onEnded={handleVideoEnd}
      >
        <source
          src={`/videos/${role}-end-video.mov`}
          type="video/mp4"
        />
      </video>
    </motion.div>
  )
}
